export enum GeographyName {
  NORTH_AMERICA = "North America",
  EUROPE = "Europe",
  ASIA = "Asia/Pacific",
  SOUTH_AMERICA = "South America",
  GLOBAL = "Global",
  Africa = "Africa",
  MENA = "Middle-East-North Africa",
}
